import http from './http';

import {
    GET_ALL_PROMO_CODES_ENDPOINT,
    CREATE_PROMO_CODE_ENDPOINT,
    DELETE_PROMO_CODE_ENDPOINT,
    CHECK_PROMO_CODE_ENDPOINT,
    UPDATE_PROMOTION_ENDPOINT,
    generateEndpoint,
} from '../services/endpoints';

export default (() => {

    function check(params) {

        return http.post(CHECK_PROMO_CODE_ENDPOINT, params);
    }

    function getAll() {

        return http.get(GET_ALL_PROMO_CODES_ENDPOINT);
    }

    function create(options) {

        return http.post(CREATE_PROMO_CODE_ENDPOINT, options);
    }

    function update(options) {

        const endpoint = generateEndpoint(UPDATE_PROMOTION_ENDPOINT, { id: options.id });

        return http.put(endpoint, options);
    }

    function remove(promoId) {

        const endpoint = generateEndpoint(DELETE_PROMO_CODE_ENDPOINT, { id: promoId });

        return http.delete(endpoint);
    }

    function typeToDescription(type) {

        switch (type) {

            case 'free_place':
                return 'Free Place Discount';

            case 'fixed_value':
                return 'Fixed Value Discount';

            case 'fixed_percentage':
                return 'Fixed Percentage Discount';

            case 'multiple_delegates':
                return 'Multiple Delegates Discount (10% off)';

            default:
                return 'Unknown';
        }
    }

    return {
        create,
        update,
        remove,
        getAll,
        check,
        typeToDescription
    };

})();


// WEBPACK FOOTER //
// ./services/promotionCodes.js